import { DatePipe } from '@angular/common';
import { Component, OnInit, OnDestroy, AfterViewInit, ViewChildren, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatOption, MatSelect, MatTableDataSource, Sort } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, takeUntil, tap } from 'rxjs/operators';
import { Message } from 'src/app/core/class/message';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { CommonService } from 'src/app/core/services/common.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { ResponsiveService } from 'src/app/core/services/responsive.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
@Component({
  selector: 'app-export-data-customer',
  templateUrl: './export-data-customer.component.html',
  styleUrls: ['./export-data-customer.component.scss'],
})
export class ExportDataCustomerComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChildren('focus') focus;

  displayedColumns: string[] = [];

  columnDefinitions = [
    { def: "id", showMobile: true },
    { def: "name", showMobile: true },
    { def: "type", showMobile: true },
    { def: "createdTime", showMobile: true },
    { def: "status", showMobile: true },
    { def: "action", showMobile: true },
  ];

  checkFocus = true;
  createdTime: string = 'DESC'
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChild('groupCustomerSelect', { static: false }) groupCustomerSelect: MatSelect;
  @ViewChild('allSelectedGroupCustomer', { static: false }) allSelectedGroupCustomer: MatOption;
  @ViewChild('allSelectedTest', { static: false }) allSelectedTest: MatOption;
  selectGroupCustomerMap = new Map();
  paginate: {
    currentPage: number,
    pageSize: number,
    totalRow: number,
    totalPage: number,
    totalPageArray: [],
    no: []
  };
  error = '';
  exportTime: any;
  subscription: Subscription;
  groupCustomerFilterCtrl: FormControl = new FormControl();
  groupCustomers: any[] = [];
  dataSelected: any;
  dataCustomerSelected: any;
  keyword: string = '';
  private _onDestroy = new Subject<void>();

  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;

  constructor(
    public commonService: CommonService,
    private route: ActivatedRoute,
    private router: Router,
    private responsiveService: ResponsiveService,
    private customerService: CustomerService,
    private datepipe: DatePipe,
    private toastr: ToastrService,
    private dialog: MatDialog,
    public message: Message,
  ) {
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
  }

  ngOnInit() {
    this.getAllGroupCustomer();
    this.getAllExportHistory(this.paginate.currentPage, this.paginate.pageSize);
    this.groupCustomerFilterCtrl.valueChanges.pipe(
      takeUntil(this._onDestroy),
      tap((value) => this.keyword = value),
      debounceTime(300)
    )
      .subscribe(
        value => {
          this.getAllGroupCustomer(0, 9999999);
        });
  }

  ngOnDestroy() {
    this.subscribeMediaBreakPointService.unsubscribe();
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focus.first.nativeElement.focus());
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
    }
  }

  getAllGroupCustomer(page: number = 0, pageSize: number = 9999999) {
    this.customerService.filterGroupCustomer({
      page,
      pageSize,
      keyword: this.keyword
    }).subscribe((rs) => {
      if (rs == null || rs.data == null || rs.data.content == null) {
        return 0;
      }
      this.groupCustomers = rs.data.content;
    });
  }

  getAllExportHistory(page: number = 0, pageSize: number = 10) {
    this.customerService.filterExportHistory({
      page,
      pageSize,
      sorts: { createdTime: this.createdTime }
    }).subscribe((rs) => {
      console.log(rs);
      if (rs == null || rs.data == null || rs.data.content == null) {
        return 0;
      }
      this.paginate = {
        currentPage: rs.data.pageable.page,
        pageSize: rs.data.pageable.size,
        totalRow: rs.data.total,
        totalPage: Math.ceil(rs.data.total / rs.data.pageable.size),
        totalPageArray: this.commonService.counter(Math.ceil(rs.data.total / rs.data.pageable.size), 1),
        no: this.commonService.counter(rs.data.pageable.size, rs.data.pageable.page * rs.data.pageable.size + 1)
      };
      this.dataSource.data = rs.data.content.map((data, index) => ({
        ...data,
        index: rs.data.pageable.page * 10 + index,
        type: data.type === 'DSKHdaydu' ? 'Dạng đầy đủ' : 'Dạng rút gọn'
      }));
    })
  }

  renderStatusColor(status: any): object {
    switch (status) {
      case 3:
        return { 'color': 'red', 'border': '1px solid red', 'border-radius': '5px' };
      case 1:
        return { 'color': 'blue', 'border': '1px solid blue', 'border-radius': '5px' };
      default:
        return { 'color': 'green', 'border': '1px solid green', 'border-radius': '5px' };
    }
  }

  exportData(isExportFullCustomerInformation: boolean, isReExport: boolean = false, dataRequest?: any, isExportNonGroup?: boolean, isExportAll?: boolean) {
    this.exportTime = null;
    let data = {
      requestExportCustomerGroup: {
        customerGroupIds: isReExport ? (dataRequest.customerGroupIds ? dataRequest.customerGroupIds : null) : (this.dataSelected ? this.dataSelected : null),
        customerIds: isReExport ? (dataRequest.customerIds ? dataRequest.customerIds : null) : null,
        isExportByGroup: isReExport ? dataRequest.isExportByGroup : true,
        isExportFullCustomerInformation: isExportFullCustomerInformation,
        isExportNonGroup: false,
        isExportAll: false
      }
    };
    if ((data.requestExportCustomerGroup.customerGroupIds && data.requestExportCustomerGroup.customerGroupIds.length > 0) || isExportNonGroup || isExportAll ) {
      if (isExportNonGroup) {data.requestExportCustomerGroup.customerGroupIds.push('isExportNonGroup'); }
      if (isExportAll) {data.requestExportCustomerGroup.customerGroupIds.push('isExportAll'); }
      if (!data.requestExportCustomerGroup.customerGroupIds || data.requestExportCustomerGroup.customerGroupIds.length === 0) {
        data.requestExportCustomerGroup.customerGroupIds = [];
      } else {
        const hasExportNonGroup  = data.requestExportCustomerGroup.customerGroupIds.find( item => item === 'isExportNonGroup');
        const hasExportAll  = data.requestExportCustomerGroup.customerGroupIds.find( item => item === 'isExportAll');
        data.requestExportCustomerGroup.isExportNonGroup = hasExportNonGroup  ? true : false;
        data.requestExportCustomerGroup.isExportAll = hasExportAll  ? true : false;
        data.requestExportCustomerGroup.customerGroupIds = data.requestExportCustomerGroup.customerGroupIds.filter(item => item !== 'isExportNonGroup' && item !== 'isExportAll');
        if (data.requestExportCustomerGroup.customerGroupIds.length === 0) {
          data.requestExportCustomerGroup.isExportByGroup = false;
        }
      }
      this.customerService.createExportExcelHistory(data).subscribe({
        next: (rs) => {
          if (rs && (rs.code == ErrorCode.ExportGroupCustomerNotFound || rs.code == ErrorCode.ExportGroupCustomerNotPermission || rs.code == ErrorCode.ExportCustomerNotPermission || rs.code == ErrorCode.ExportCustomerNotFound)) {
            this.toastr.error(rs.message);
            return;
          }
          if (rs == null || rs.data == null) {
            return 0;
          }
          this.getAllExportHistory(this.paginate.currentPage, this.paginate.pageSize);
        }
      });
    } else {
      this.toastr.error(this.commonService.format(this.message.getMessage('messages.please_exporting_data')));
    }
  }

  clickOptionGroupCustomerAll() {
    if (this.allSelectedGroupCustomer.selected) {
      this.groupCustomerSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.select();
      });
      this.allSelectedTest.select();
      this.groupCustomers.forEach((data) => {
        this.selectGroupCustomerMap.set(data.id, data);
      });
    } else {
      this.groupCustomerSelect.options.filter(x => x.value !== undefined && x.value !== -1).forEach((item: MatOption) => {
        item.deselect();
      });
      this.allSelectedTest.deselect();
      this.groupCustomers.forEach((data) => {
        this.selectGroupCustomerMap.delete(data.id);
      });
    }
  }

  clickOptionTest() {
    if (!this.allSelectedTest.selected) {
      this.allSelectedGroupCustomer.deselect();
    }
    if (this.selectGroupCustomerMap.size === this.groupCustomers.length && this.allSelectedTest.selected ) {
      this.allSelectedGroupCustomer.select();

    }
  }

  clickOptionGroupCustomer(groupCustomer) {
    if (groupCustomer) {
      if (this.selectGroupCustomerMap.has(groupCustomer.id)) {
        this.selectGroupCustomerMap.delete(groupCustomer.id);
      } else {
        this.selectGroupCustomerMap.set(groupCustomer.id, groupCustomer);
      }
      if (this.selectGroupCustomerMap.size !== this.groupCustomers.length  ) {
        this.allSelectedGroupCustomer.deselect();
      }
      if (this.selectGroupCustomerMap.size === this.groupCustomers.length && this.allSelectedTest.selected  ) {
        this.allSelectedGroupCustomer.select();
      }
    } else {
      if (this.selectGroupCustomerMap.has(0)) {
        this.selectGroupCustomerMap.delete(0);
      } else {
        this.selectGroupCustomerMap.set(0, 0);
      }
    }
    if (this.allSelectedGroupCustomer.selected) {
      this.allSelectedGroupCustomer.deselect();
    }
    if (this.groupCustomerSelect.options.length - 2 === this.dataSelected.length) {
      this.allSelectedGroupCustomer.select();
    }
  }

  viewDataExport(id: string) {
    this.customerService.getExportHistoryById(id).subscribe((rs) => {
      if (rs == null || rs.data == null || rs.data.requestExportCustomerGroup == null) {
        return 0;
      }
      if(rs.data.requestExportCustomerGroup.customerIds) {
        this.dataSelected = [];
        this.toastr.error(this.commonService.format(this.message.getMessage('toastr_report.noti_view_export_data_fail')));
      } else {
        if (rs.data.requestExportCustomerGroup.isExportNonGroup) {
          const isExportNonGroup = 'isExportNonGroup';
          rs.data.requestExportCustomerGroup.customerGroupIds.push(isExportNonGroup);
        }
        if (rs.data.requestExportCustomerGroup.isExportAll) {
          const isExportAll = 'isExportAll';
          rs.data.requestExportCustomerGroup.customerGroupIds.push(isExportAll);
        }
        this.exportTime = rs.data.exportTime;
        this.dataSelected = rs.data.requestExportCustomerGroup.customerGroupIds;
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
        return;
      }
    });
  }

  reExportData(id: string) {
    this.customerService.getExportHistoryById(id).subscribe((rs) => {
      console.log(rs);
      if (rs == null || rs.data == null || rs.data.requestExportCustomerGroup == null) {
        return 0;
      }
      this.exportData(rs.data.requestExportCustomerGroup.isExportFullCustomerInformation, true, rs.data.requestExportCustomerGroup, rs.data.requestExportCustomerGroup.isExportNonGroup, rs.data.requestExportCustomerGroup.isExportAll);
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    })
  }

  downloadDataExport(id: string, filename: string) {
    this.customerService.downloadExcel(id).subscribe(rs => {
      if (rs) {
        this.toastr.success(this.commonService.format(this.message.getMessage('toastr_report.download_success')));
        this.downLoadFile(rs, 'application/vnd.openxmlformats officedocument.spreadsheetml.sheet', filename);
      } else
        this.toastr.error(rs.message);
    });
  }

  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], { type });
    if (window.top.navigator.msSaveOrOpenBlob) {
      // Store Blob in IE
      window.top.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // Store Blob in others
      const tA = document.body.appendChild(document.createElement('a'));
      tA.href = URL.createObjectURL(blob);
      tA.download = fileName;
      tA.style.display = 'none';
      tA.click();
      tA.parentNode.removeChild(tA);
    }
  }

  deleteDataExport(id: string, name: string) {
    const dialogConfirm = this.dialog.open(WarningComponent, {
      data: this.commonService.format(this.message.getMessage('messages.delete_file'), name),
      width: '40%'
    });
    dialogConfirm.afterClosed().subscribe(rs => {
      if (rs) {
        this.customerService.deleteExportHistory(id).subscribe((rs) => {
          if(rs && rs.success) {
            if (this.dataSource.data.length === 1 && this.paginate.currentPage > 0) {
              this.paginate.currentPage--
            }
            this.toastr.success(this.commonService.format(this.message.getMessage('toastr_report.delete_data_success')))
            this.getAllExportHistory(this.paginate.currentPage, this.paginate.pageSize);
            return;
          }
          this.toastr.error(rs.message);
          this.getAllExportHistory(this.paginate.currentPage, this.paginate.pageSize);
        })
      }
    });
  }

  onChangeSort(e: Sort) {
    if (e.direction === '') {
      return;
    }
    console.log(e.direction)
    this.createdTime = e.direction.toUpperCase()
    this.getAllExportHistory(this.paginate.currentPage, this.paginate.pageSize);
  }

}


